import { gql } from '@apollo/client';

export const GET_GEOJSON = gql`
  query geojson($countryList: [String]!) {
    geojson(countryList: $countryList) {
      features
    }
  }
`;
